export default "__VITE_ASSET__BdW7T1t9__"